export enum FlexBoxAlignItems {
  /**
   * Items are aligned toward the start of the flex-direction.<br />
   * <b>Note:</b> Corresponds to `flex-start`.
   */
  Start = 'Start',
  /**
   * Items are centered.<br />
   * <b>Note:</b> Corresponds to `center`.
   */
  Center = 'Center',
  /**
   * Items are aligned toward the end of the flex-direction.<br />
   * <b>Note:</b> Corresponds to `flex-end`.
   */
  End = 'End',
  /**
   * Items are aligned by their baseline.<br />
   * <b>Note:</b> Corresponds to `baseline`.
   */
  Baseline = 'Baseline',
  /**
   * Items are stretched to fill the container.<br />
   * <b>Note:</b> Corresponds to `stretch`.
   */
  Stretch = 'Stretch'
}
